import React from "react";
import services from "./Services.jsx";
import IronScrapSection from "./IronScrapSection.jsx";
import CopperScrap from "./CopperScrap.jsx";
import Services from "./Services";
import SEO from "../Components/SEO";

function Scrapservices1() {
return(
    <>
         <SEO 
           title="All Scrap Services" 
           description="Learn about our comprehensive metal recycling services. Jaina Enterprises is your reliable partner for industrial scrap solutions."
           keywords="all scrap services, metal recycling solutions, bulk scrap buying, copper iron scrap recycling"
         />
          <Services/>
        <IronScrapSection/>
        <CopperScrap/>
        </>
)
}
export default Scrapservices1;